export async function fetchDocumentBytes(url: string): Promise<ArrayBuffer> {
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`Failed to load document (${response.status})`);
    }
    return response.arrayBuffer();
}
